<template>
  <el-dialog title="新建/编辑" :visible.sync="formVisible" width="800px">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <!-- 账号信息部分 -->
      <div class="form-section">
        <div class="section-title">账号信息</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账号(用于登录)" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入账号" :disabled="!!form.id" />
            </el-form-item>
            <el-form-item label="姓名" prop="realName">
              <el-input v-model="form.realName" placeholder="请输入姓名" />
            </el-form-item>
            <el-form-item label="角色">
              <el-select v-model="form.sysRoleList" style="width:100%;" placeholder="请选择" filterable clearable multiple>
                <el-option v-for="item in options.sysRole" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="entryInhibited">
              <el-switch 
                v-model="form.entryInhibited" 
                :active-value="0" 
                :inactive-value="1"
                active-text="启用"
                inactive-text="禁用">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <el-input v-if="!editingSelf" v-model="form.password" type="password" maxlength="64"
                :placeholder="form.id ? '留空保留原密码' : '请输入密码'" />
              <span v-else>修改本人密码请使用右上角个人中心</span>
            </el-form-item>
            <el-form-item label="头像" prop="headImg">
              <imageUpload v-model="form.headImg" width="32" height="32" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 权限配置部分 -->
      <div class="form-section">
        <div class="section-title">权限配置(审核折扣配置、线下充值，会议报名审核)</div>
        <el-form-item label="查看数据权限:">
          <div style="display: flex; gap: 10px; align-items: flex-start;">
            <el-select 
              v-model="form.dataScopeType" 
              style="width: 200px;" 
              placeholder="选择类型/全部" 
              clearable
              @change="handleDataScopeTypeChange"
              @clear="handleDataScopeTypeClear">
              <el-option label="全部" :value="0"></el-option>
              <el-option label="角色" :value="10"></el-option>
              <el-option label="用户/账号" :value="20"></el-option>
            </el-select>
            <el-select 
              v-if="form.dataScopeType === 10" 
              :key="'role-' + form.dataScopeType"
              v-model="form.dataScopeRoleIds" 
              style="width: 200px;" 
              placeholder="请选择" 
              filterable 
              clearable 
              multiple
              @remove-tag="handleRemoveRoleTag">
              <el-option 
                v-for="item in options.dataScopeRoles" 
                :key="item.id" 
                :label="item.roleName" 
                :value="item.id">
              </el-option>
            </el-select>
            <el-select 
              v-if="form.dataScopeType === 20" 
              :key="'user-' + form.dataScopeType"
              v-model="form.dataScopeUserIds" 
              style="width: 200px;" 
              placeholder="请选择" 
              filterable 
              clearable 
              multiple
              @remove-tag="handleRemoveUserTag">
              <el-option 
                v-for="item in options.dataScopeUsers" 
                :key="item.id" 
                :label="item.userName+'('+item.realName+')'" 
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </div>
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import userApi from '@/api/system/user'
import sysRoleApi from '@/api/system/sysRole'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    userName: null,
    password: null,
    deptId: null,
    sysRoleList: [],
    entryInhibited: 1,
    dataScopes: null,
    dataScopeType: null,
    dataScopeRoleIds: [],
    dataScopeUserIds: []
  }
  return formBean
}

export default {
  name: 'UserAdd',
  components: { ImageUpload },
  data() {
    return {
      options: {
        sysDept: [],
        sysRole: [],
        dataScopeRoles: [],
        dataScopeUsers: []
      },
      form: initFormBean(),
      formVisible: false,
      formRules: {
        userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ validator: (rule, value, callback) => {
          if (!this.form.id && (!value || !value.trim())) return callback(new Error('请输入密码'))
          if (value && !value.trim()) return callback(new Error('密码不能全为空格'))
          callback()
        }, trigger: 'blur' }],
        deptId: []
      }
    }
  },
  computed: {
    editingSelf() {
      return !!this.form.id && String(this.form.id) === String(this.$store.state.user.userId)
    }
  },
  created() {
    sysRoleApi.findOptions().then(data => { this.options.sysRole = data.data })
    this.loadDataScopeOptions()
  },
  methods: {
    /**
     * 加载数据权限选项
     */
    loadDataScopeOptions() {
      // 加载角色列表
      sysRoleApi.fetchList({ pageNo: 1, pageSize: 10, roleStatus: 1 }).then(({ data }) => {
        this.options.dataScopeRoles = data.list || []
      })
      // 加载用户列表
      userApi.fetchList({ pageNo: 1, pageSize: 1000, userType: 1, entryInhibited: 0 }).then(({ data }) => {
        this.options.dataScopeUsers = data.list || []
      })
    },
    /**
     * 数据权限类型改变
     */
    handleDataScopeTypeChange(value) {
      // 使用 $set 确保响应式更新，清空之前的选择
      if (value === null || value === undefined) {
        // 清空类型时，清空所有相关数据
        this.$set(this.form, 'dataScopeRoleIds', [])
        this.$set(this.form, 'dataScopeUserIds', [])
      } else if (value === 0) {
        // 全部，清空其他选择
        this.$set(this.form, 'dataScopeRoleIds', [])
        this.$set(this.form, 'dataScopeUserIds', [])
      } else if (value === 10) {
        // 角色，清空用户选择
        this.$set(this.form, 'dataScopeUserIds', [])
      } else if (value === 20) {
        // 用户/账号，清空角色选择
        this.$set(this.form, 'dataScopeRoleIds', [])
      }
    },
    /**
     * 数据权限类型清除
     */
    handleDataScopeTypeClear() {
      // 清除类型时，清空所有相关数据
      this.$set(this.form, 'dataScopeRoleIds', [])
      this.$set(this.form, 'dataScopeUserIds', [])
    },
    /**
     * 处理用户标签移除
     */
    handleRemoveUserTag(value) {
      const index = this.form.dataScopeUserIds.indexOf(value)
      if (index > -1) {
        this.form.dataScopeUserIds.splice(index, 1)
      }
    },
    /**
     * 处理角色标签移除
     */
    handleRemoveRoleTag(value) {
      const index = this.form.dataScopeRoleIds.indexOf(value)
      if (index > -1) {
        this.form.dataScopeRoleIds.splice(index, 1)
      }
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      userApi.fetchById(row.id).then(({ data }) => {
        this.form = data
        this.form.password = ''
        this.$set(this.form, 'sysRoleList', data.sysRoleList.map(it => it.id))
        
        // 初始化数据权限字段（确保响应式）
        this.$set(this.form, 'dataScopeType', null)
        this.$set(this.form, 'dataScopeRoleIds', [])
        this.$set(this.form, 'dataScopeUserIds', [])
        
        // 处理数据权限
        if (data.dataScopes) {
          const dataScope = data.dataScopes
          if (dataScope) {
            this.$set(this.form, 'dataScopeType', dataScope.type)
          
            if (dataScope.type === 10 && dataScope.roleIds) {
              this.$set(this.form, 'dataScopeRoleIds', dataScope.roleIds.split(',').map(id => parseInt(id)))
            } else if (dataScope.type === 20 && dataScope.userIds) {
              this.$set(this.form, 'dataScopeUserIds', dataScope.userIds.split(',').map(id => parseInt(id)))
            }
          }
        }
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form))
          if (this.form.id && (!params.password || this.editingSelf)) delete params.password
          
          // 处理数据权限参数
          if (this.form.dataScopeType !== null && this.form.dataScopeType !== undefined) {
            // 如果是"全部"类型，或者选择了类型但没有选择具体数据，传 null
            if (this.form.dataScopeType === 0) {
              params.dataScopes = {
                  type: this.form.dataScopeType,
                  roleIds: '',
                  userIds: ''
                }
            } else if (this.form.dataScopeType === 10) {
              // 角色类型
              if (this.form.dataScopeRoleIds && this.form.dataScopeRoleIds.length > 0) {
                params.dataScopes = {
                  type: this.form.dataScopeType,
                  roleIds: this.form.dataScopeRoleIds.join(','),
                  userIds: ''
                }
              } else {
                // 选择了角色类型但没有选择具体角色，传 null
                params.dataScopes = null
              }
            } else if (this.form.dataScopeType === 20) {
              // 用户/账号类型
              if (this.form.dataScopeUserIds && this.form.dataScopeUserIds.length > 0) {
                params.dataScopes = {
                  type: this.form.dataScopeType,
                  roleIds: '',
                  userIds: this.form.dataScopeUserIds.join(',')
                }
              } else {
                // 选择了用户类型但没有选择具体用户，传 null
                params.dataScopes = null
              }
            } else {
              params.dataScopes = null
            }
          } else {
            // 未选择类型，传 null
            params.dataScopes = null
          }
          
          // 删除临时字段
          delete params.dataScopeType
          delete params.dataScopeRoleIds
          delete params.dataScopeUserIds
          if (this.form.id > 0) {
            userApi.update(params).then((data) => {
              this.postCallback(data)
            });
          } else {
            userApi.create(params).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>

<style scoped>
.form-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #EBEEF5;
}

.dialog-footer {
  text-align: right;
}

::v-deep .el-form-item {
  margin-bottom: 18px;
}

::v-deep .el-form-item__label {
  font-weight: 500;
}

::v-deep .el-input__inner {
  border-radius: 4px;
}

::v-deep .el-select {
  width: 100%;
}
</style>
